import { CONFIGURATION_ITEM_FRAGMENT } from "@gql/fragments/configuration/configurationItemFragment";
import gql from "graphql-tag";

export const ADD_CONFIGURATION_ITEMS = gql`
  mutation AddConfigurationItems($objects: [product_cloud_configuration_item_insert_input!]!) {
    insert_product_cloud_configuration_item(objects: $objects) {
      returning {
        ...configurationItemFields
      }
    }
  }
  ${CONFIGURATION_ITEM_FRAGMENT}
`;
